import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';

/**
 * NewSessionPromptDialog
 * Pregunta qué hacer con la conversación actual (que tiene mensajes) antes de
 * empezar una nueva: guardarla en el historial (clearChat la archiva), eliminarla
 * (discardSession la borra de la vista) o cancelar (quedarse donde está). Espeja
 * el patrón AlertDialog de DeleteSessionDialog.
 */
const NewSessionPromptDialog = ({ open, onOpenChange, onSave, onDelete }) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Nueva conversación</AlertDialogTitle>
          <AlertDialogDescription>
            Esta conversación tiene contenido. ¿Quieres guardarla en el
            historial antes de empezar una nueva, o eliminarla?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col-reverse sm:flex-row sm:justify-end sm:gap-2">
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onDelete}
            className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
          >
            Eliminar
          </AlertDialogAction>
          <AlertDialogAction onClick={onSave}>
            Guardar en el historial
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default NewSessionPromptDialog;
